import { rest } from 'msw';

import { getApiHost } from '@hotjar/common';

import customersSummary from './fixtures/get-customers-summary.json';
import { registerMock } from './registerMock';

export const checkoutGetCustomersSummary = rest.get(
  `${getApiHost()}/api/checkout/customers/:accountId/summary`,
  (req, res, ctx) => {
    const responseData = {
      ...customersSummary,
    };

    return res(ctx.status(200), ctx.json(responseData));
  },
);

registerMock('checkoutGetCustomersSummary', checkoutGetCustomersSummary);

export const checkoutGetCustomersSummaryPaymentOverdue = rest.get(
  `${getApiHost()}/api/checkout/customers/:accountId/summary`,
  (req, res, ctx) => {
    const responseData = {
      ...customersSummary,
      subscription_status: 'OVERDUE',
    };

    return res(ctx.status(200), ctx.json(responseData));
  },
);

registerMock(
  'checkoutGetCustomersSummaryPaymentOverdue',
  checkoutGetCustomersSummaryPaymentOverdue,
);
